import { Modal, Form, Input } from 'antd';
import { useEffect } from 'react';

const AddShippingAddressFormModal = ({ visible, onCancel, onSave, initialValues }: {
  visible: boolean;
  onCancel: () => void;
  onSave: (values: any) => void;
  initialValues: any;
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.setFieldsValue(initialValues);
    }
  }, [visible, form, initialValues]);

  const onFinish = (values: any) => {
    onSave(values);
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      onOk={() => form.submit()}
      title="收货方信息"
      className="add-shipping-address-modal"
      okText="保存"
      cancelText="取消"
    >
      <div className="shipping-detail-info">请完善地址信息</div>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="nickName"
          label="收货人"
          rules={[{ validator: (rule, value) => {
            if (!value) {
              return Promise.reject("请输入收货人");
            }
            if (value.length > 30) {
              return Promise.reject("收货人姓名最多可输入30个字符");
            }
            return Promise.resolve();
          }}]}
        >
          <Input
          maxLength={30}
          placeholder="填写收货人" value={initialValues?.nickName}  />
        </Form.Item>
        <Form.Item
          name="phone"
          label="手机号"
          rules={[{ validator: (rule, value) => {
            if (!value) {
              return Promise.reject('请输入手机号');
            }
            const reg = /^((?:\+?86\s*)?\d{11}|\d{11}|\d{3}-\d{8}|\d{4}-\d{7})$/;
            if (!reg.test(value)) {
              return Promise.reject('手机号格式不正确');
            }
            return Promise.resolve();
          }}]}
        >
          <Input placeholder="填写手机号" value={initialValues?.phone} />
        </Form.Item>
        <Form.Item
          name="region"
          label="所在地区"
          rules={[{ validator: (rule, value) => {
            if (!value) {
              return Promise.reject('请输入所在地区');
            }
            if (value.length > 60) {
              return Promise.reject("所在地区最多可输入60个字符");
            }
            return Promise.resolve();
          }}]}
        >
          <Input
          maxLength={60}
          placeholder="XX省XX市XX区" value={initialValues?.region}/>
        </Form.Item>
        <Form.Item
          name="address"
          label="详细地址"
          rules={[{ validator: (rule, value) => {
            if (!value) {
              return Promise.reject('请输入详细地址');
            }
            if (value.length > 120) {
              return Promise.reject("详细地址最多可输入120个字符");
            }
            return Promise.resolve();
          }}]}
        >
          <Input
          maxLength={120}
          placeholder="填写详细地址, 例: 明月路1257号1号楼101" value={initialValues?.address}/>
        </Form.Item>
        <Form.Item
          name="invoice"
          label="发票抬头"
          rules={[{ validator: (rule, value) => {
            if (!value) {
              return Promise.reject('请输入发票抬头');
            }
            if (value.length > 150) {
              return Promise.reject("发票抬头最多可输入150个字符");
            }
            return Promise.resolve();
          }}]}
        >
          <Input
          maxLength={150}
          placeholder="请输入发票抬头" value={initialValues?.invoice}/>
        </Form.Item>
        {/* 其他表单项... */}
      </Form>
      <div className='add-address-note'>
         请留意：具体开票信息在您提交订单后会有客服人员联系确认，请保持电话畅通。
      </div>
    </Modal>
  );
};

export default AddShippingAddressFormModal;